import React from 'react';
import { Clock, Map, ShieldCheck, Star } from 'lucide-react';
import { TRUST_INDICATORS } from '../mock';

const iconMap = {
  clock: Clock,
  map: Map,
  'shield-check': ShieldCheck,
  star: Star
};

export const TrustBar = () => {
  return (
    <section className="relative bg-white border-y border-gray-100 py-12">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-16">
          {TRUST_INDICATORS.map((item, index) => {
            const Icon = iconMap[item.icon];
            return (
              <div key={index} className="flex items-center justify-center gap-4 group">
                <div className="w-12 h-12 bg-brand-green/8 rounded-2xl flex items-center justify-center group-hover:bg-brand-green/12 transition-all border border-brand-green/10">
                  <Icon className="w-6 h-6 text-brand-green" />
                </div>
                <span className="font-semibold text-[15px] text-gray-900">{item.label}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};